module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newTagMsg":"Add new tag","buttons":{"upload":"Upload","share":"Share","cancel":"Cancel upload","del":"Delete file"}},"fr":{"newTagMsg":"Ajouter tag","buttons":{"upload":"Uploader","share":"Partager","cancel":"Annuler l\u0027upload","del":"Supprimer le fichier"}}}')
  delete Component.options._Ctor
}
